import { useEffect, useMemo, useState } from "react";

import { Box, Grid, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";

import Navbar from "../../../components/Navbar";
import LinearStepper from "./components/Stepper";
import StepOne from "./components/StepOne";
import StepTwo from "./components/StepTwo";
import Review from "../../assets/asset-form/components/Review";
import { useLocation } from "react-router-dom";
import Gobutton from "../../../components/Gobutton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// Default AI Feature asset template
const defaultAIFeatureAsset = {
  id: "",
  Title: "",
  privateId: "",
  video: "",
  Image: "",
  desc: "",
  editorUrl: "",
  status: "review",
};

const featuresSteps = ["Create AI Feature", "Add Link"];
const editFeaturesSteps = ["Edit AI Feature", "Edit Link"];

export default function FeatureForm() {
  const [asset, setAsset] = useState(defaultAIFeatureAsset);
  const [activeStep, setActiveStep] = useState(0);

  const location = useLocation();

  // pull editableAsset from navigation state
  const { editableAsset } = location.state || {};

  // decide steps depending on mode
  const steps = useMemo(
    () => (editableAsset ? editFeaturesSteps : featuresSteps),
    [editableAsset]
  );

  const resetAsset = () => {
    setActiveStep(0);
    setAsset(defaultAIFeatureAsset);
  };

  // set asset when editing
  useEffect(() => {
    if (editableAsset && editableAsset.id) {
      setAsset(editableAsset);
    }
  }, [editableAsset]);

  // reset only when creating (no editableAsset)
  useEffect(() => {
    if (!editableAsset) {
      resetAsset();
    }
  }, [location.pathname, editableAsset]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Navbar />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
        className="w-full px-3 max-w-[1150px]"
      >
        <Grid container justifyContent="space-between" alignItems="center" >
        <Typography variant="h5" sx={{ alignSelf: "start" }}>
          {!editableAsset ? "Create AI Feature" : "Edit AI Feature"}
        </Typography>

        <Gobutton
            text={"Back to List"}
            endIcon={<ArrowForwardIcon />}
            url={{ type: "assets", url: '/ai-features' }}
        />          
        </Grid>

        <LinearStepper
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          asset={asset}
          resetAsset={resetAsset}
          steps={steps}
        >
          <Paper
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: 4,
              margin: 2,
              gap: 2,
            }}
            elevation={4}
          >
            {activeStep === 0 && <StepOne asset={asset} setAsset={setAsset} />}
            {activeStep === 1 && <StepTwo asset={asset} setAsset={setAsset} />}
            {activeStep === 2 && <Review asset={asset} setAsset={setAsset} />}
          </Paper>
        </LinearStepper>
      </Box>
    </Box>
  );
}
